<template>
    <div>

        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" />

        <label class="form-label mt-3" style="color: #AB0000"> Dados do Chamado</label>
        <Card_Title :class_color="'bg-color-4'">
            <template v-slot:context>

                <div class="col-12">

                    <div class="row">
                        <div class="col">
                            <label class="form-label">Status</label>
                            <input label="nmStatus" name="nmStatus" class="form-control shadow-v2" v-model="chamado.nmStatus" readonly />
                        </div>
                        <div class="col">
                            <label class="form-label">Tipo Chamado</label>
                            <vue-select v-model="tipo_chamado_select" :label-by="format_nmTipoChamado" :options="tipos_chamado" placeholder="Selecione o Tipo de Chamado" class="form-control shadow-v2 hig-Input" close-on-select clear-on-select :min="1"></vue-select>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Título</label>
                            <input label="dsTitulo" name="dsTitulo" class="form-control shadow-v2" v-model="chamado.dsTitulo" readonly />
                        </div>
                        <div class="col">
                            <label class="form-label">Nr° DevOps</label>
                            <input label="nrDevOps" name="nrDevOps" class="form-control shadow-v2" v-model="chamado.nrDevOps" readonly />
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Descrição do Chamado</label>
                            <textarea label="dsChamado" name="dsChamado" class="form-control shadow-v2" v-model="chamado.dsChamado" rows="4" readonly />
                        </div>
                    </div>

                    <div v-if="tipo_chamado_select_atual.idTipoChamado != tipo_chamado_select.idTipoChamado" class="mt-3">
                        <div class="col">
                            <label class="form-label">Motivo da Alteração do Tipo Chamado</label>
                            <input label="dsMotivo" name="dsMotivo" class="form-control shadow-v2" v-model="tipo_chamado_post.dsMotivo" />
                        </div>
                        <div class="col">
                            <!--v-if="tipo_chamado_post.dsMotivo !== ''"-->
                            <button type="button" class="btn btn-red-v2 float-end mt-3 mb-3" @click="saveTipoChamadoCrud()">
                                <i class="fas fa-save pe-2"></i>
                                Alterar
                            </button>
                        </div>
                    </div>

                </div>
            </template>
        </Card_Title>
    </div>
</template>

<script>

    import axios from 'axios';
    import OcorrenciaInfo from '../../../../components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import Card_Title from '@/components/App/Card_Title.vue';
    import VueNextSelect from "vue-next-select";
    import "vue-next-select/dist/index.min.css";

    export default {
        name: 'Dados do Chamado',
        components: {
            "vue-select": VueNextSelect,
            OcorrenciaInfo,
            Card_Title
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                tipos_chamado: [{ idTipoChamado: 0, nmTipoChamado: '' }],
                ocorrencia: {},
                dados: { cdInstituicao: 0, nrMesesCliente: 0 },
                chamado: {},
                filtro_text: '',
                tipo_chamado_select_atual: {},
                tipo_chamado_select: {},
                tipo_chamado_post: { idOcorrencia: 0, idChamado: 0, idTipoChamado: 0, dsMotivo: '' }
            }
        },
        mounted() {
            this.getTiposChamado();
            this.getOcorrencia();
        },
        methods: {
            getTiposChamado() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/TipoChamado/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.tipos_chamado = response.data.data;
                })
            },
            format_nmTipoChamado(tipo) {
                return tipo.nmTipoChamado;
            },
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.getDadosOcorrencia();
                })
            },
            getDadosOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetDadosOcorrencia?idOcorrencia=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.dados = response.data.data;
                    $this.getDadosChamado();
                })
            },
            getDadosChamado() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Chamado/Get?id=' + $this.ocorrencia.idChamado, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.chamado = response.data.data;

                    $this.tipo_chamado_select_atual = $this.tipos_chamado.find((e) => {
                        return $this.chamado.idTipoChamado == e.idTipoChamado;
                    });

                    $this.tipo_chamado_select = $this.tipos_chamado.find((e) => {
                        return $this.chamado.idTipoChamado == e.idTipoChamado;
                    });

                    $this.tipo_chamado_post.idOcorrencia = $this.ocorrencia.idOcorrencia;
                    $this.tipo_chamado_post.idChamado = $this.chamado.idChamado;
                    $this.tipo_chamado_post.idTipoChamado = $this.chamado.idTipoChamado;
                })
            },
            saveTipoChamadoCrud() {
                let $this = this;

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Chamado/PostAlteraTipoChamado', $this.tipo_chamado_post, {
                    headers: this.$api.getTokenComercial()
                }).then(response => {
                    $this.getDadosChamado();
                }).catch(function (error) {
                    var msg = 'Ocorreu um erro inesperado';
                    if (error.response) {
                        if (error.response.data.erros != '') {
                            msg = error.response.data.errors[0];
                        } else {
                            msg = error.response.data.msg;
                        }
                    }

                    $this.$toast.show('alert', msg, true);
                });
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
        },
        watch: {
            tipo_chamado_select(newVal, oldVal) {
                this.tipo_chamado_post.idTipoChamado = newVal.idTipoChamado;
            },
            idOcorrencia(newVal, oldVal) {
                this.getOcorrencia(newVal);
            },
        },
    }

</script>

<style scoped lang="scss">

    .card-dados {
        font-size: 14px;
        cursor: pointer;
    }

    .cart-title-span {
        font-weight: bold;
        margin-left: 5px;
    }

    .card-idt {
        height: 5px;
        border-bottom: 1px solid #BBBBBB;
        margin-top: 10px;
        left: 15%;
        position: absolute
    }

    .card-line {
        height: 5px;
        border-bottom: 1px solid #BBBBBB;
        /*margin-top: 10px;*/
        position: absolute
    }

    .card-cont {
        height: 5px;
        border-bottom: 1px solid #BBBBBB;
        margin-top: 10px;
        left: 11%;
        position: absolute;
        min-width: 87.4%;
    }



    .bg-color-4 {
        background-color: #AB0000;
    }

    .row-dados {
        padding: 30px;
    }

    .accordion-button:not(.collapsed) {
        background-color: #9f3129ad;
        color: black
    }

    .box-dados {
        min-height: 200px;
        font-size: 11px;
    }

    .box-info {
        min-height: 150px;
        font-size: 14px;
    }



    .card-text-sim {
        font-weight: bold;
        margin-left: 5px;
        font-size: 18px;
        color: #00AB11;
    }

    .card-text-nao {
        font-weight: bold;
        margin-left: 5px;
        font-size: 18px;
        color: #AB0000;
    }

    .card-text-neutro {
        float: right;
        font-weight: bold;
        margin-left: 5px;
        font-size: 18px;
        color: #F4F4F4;
    }

    .line-card {
        border-radius: 10px 0px 0px 10px;
        max-width: 10px;
        margin-left: -3px;
        margin-top: -1px;
        margin-bottom: -2px;
    }

    .canvas {
        max-width: 600px;
        margin: 0 auto;
    }


    .btn-white-v3 {
        background: white;
        box-shadow: 0px 0px 4px 0px #00000040;
        /*border-radius: 5px 5px 5px 40px;*/
        min-height: 40px;
        padding: 0 35px 3px 35px;
        color: #9F3029;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #9F3029;
    }

    .btn-white-v3:hover {
        color: white;
        background: #9F3029 !important;
        border: 1px solid #9F3029 !important;
    }

    @media screen and (max-width:1400px) {
        .card-cont {
            left: 15%;
            min-width: unset;
        }
    }
</style>